import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { useNavigate } from 'react-router-dom';
import { sources } from '../api/sources';
import { useGlobalState } from '../shared/state';
import { Error } from '../shared/types';
import { Pages } from '../shared/pages';
import LogCannon from '@ace-clublabs/log-cannon';
import Spinner from '../components/Spinner';

const PaymentRouter: React.FC = () => {
  const { id } = useParams<{ id: string }>() ?? { id: undefined };
  const [, setManifest] = useGlobalState('manifest');
  const [, setPaymentType] = useGlobalState('paymentType');
  const [skipLanding, setSkipLanding] = useGlobalState('skipLanding');
  const [, setManifestId] = useGlobalState('manifestId');
  const [, setError] = useGlobalState('error');

  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        if (!skipLanding) {
          // if (id === undefined) { // TODO: add a handler for the case when manifest doesn't exist
          //   throw { message: "manifest doesn't exist", type: ErrorType.MANIFEST_ERROR };
          // }
          setSkipLanding(true);
          setManifestId(id);
          const _manifest = await sources.getManifest(id ?? '');
          setManifest(_manifest);
          setPaymentType(_manifest?.paymentType);
          const renderSchedulePayment = _manifest.schedulePayment?.enabled && _manifest.schedulePayment?.minimumDueDate;
          if (renderSchedulePayment) navigate(Pages.SchedulePayment);
          else {
            navigate(Pages.PaymentMethods);
          }
        } else {
          setSkipLanding(false);
          navigate(-1);
        }
      } catch (e: any) {
        const error: Error = {
          errorMessage: e.message,
          errorType: e.type,
        };
        setError(error);
        const errorMessage = 'ERROR: Error occured on PaymentRouter';
        LogCannon.blast(errorMessage, error);
        navigate(Pages.Error);
      }
    })();
  }, [id]);

  return <Spinner />;
};

export default PaymentRouter;
